<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px">
  <div class="col col-xs-12">
    <div class="padding-main-side table-filter">
      <!--page body contant -->
      <!--header-->
      <div class="row row-replace add-m-b">
        <div class="col-md-6 col-9 col-p h5">
          <h4 class="heading-super mb-2">
            <i class="fa fa-qrcode"></i> My Booking History & QR Code
          </h4>
        </div>
        <div class="col-md-6 col-3 top-corner-items col-p">
          <button
            class="btn btn-primary btn-sm m-r-5"
            [routerLink]="['/dashboard/apply-workplace']"
          >
            <i class="fa fa-plus"></i> Create new Permission
          </button>
          <a
            href="{{
              httpBasePath.basePath$
            }}/uploads/Sodexo_HRMS_-_Training_Slides_Desk_Booking_System.pptx"
            style="color: black"
            class="m-r-5"
          >
            <button type="button" class="btn btn-warning btn-sm m-l-5">
              How to book Seat ?
            </button></a
          >
          <span class="home-1" [routerLink]="['/dashboard']">
            <i class="fa fa-home ml-3" style="font-size: 37px"></i>
          </span>
        </div>
      </div>
      <!--end header-->

      <div class="row m-t-30">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table bg-white" cellspacing="0" width="100%">
              <thead class="bg-table-header1">
                <tr>
                  <th>Sr No.</th>
                  <th>Permission ID</th>
                  <th>Approver</th>
                  <th>Status</th>
                  <th>Booked By</th>
                  <th>Booked For</th>
                  <th>Office</th>
                  <th>Seat No / Meeting Room</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Check-In Details</th>
                  <th>QR Code</th>
                  <th>Is Checked Out ?</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tr *ngFor="let data of myPermissions; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ data.prmsn_id }}</td>
                <td>
                  <div *ngIf="!data.isAuto_approve">
                    {{ data.approver }}
                  </div>
                </td>
                <td>
                  <div *ngIf="data.isAuto_approve">
                    {{ data.remark }}
                  </div>
                  <div *ngIf="!data.isAuto_approve">
                    {{ data.status }}
                  </div>
                </td>
                <td>{{ data.EmpName }}</td>
                <td>{{ data.BookedForEmpName }}</td>
                <td>{{ data.offc_name }}</td>
                <td>{{ data.seat_id }}</td>
                <td>{{ data.book_date_from | date : "dd-MM-yyyy" }}</td>
                <td>{{ data.book_time_from }} - {{ data.book_time_to }}</td>
                <td *ngIf="data.check_in_time != '0000-00-00 00:00:00'">
                  <b> Time: </b> <br />
                  {{ data.check_in_time }} <br />
                  <span *ngIf="data.check_in_oxygen">
                    <b> Oximeter: </b> {{ data.check_in_oxygen }}</span
                  >
                  <br />
                  <span *ngIf="data.check_in_temp">
                    <b> Temprature: </b> {{ data.check_in_temp }}</span
                  >
                </td>
                <td *ngIf="data.check_in_time == '0000-00-00 00:00:00'"></td>
                <td>
                  <div
                    class="btn-group btn-group-sm"
                    *ngIf="data.qr_code_attach !== ''"
                  >
                    <button
                      class="btn-success"
                      *ngIf="data.is_widrn == 0"
                      type="button"
                      (click)="qrCodeModal('#qr_code_modal', data)"
                    >
                      View QR Code
                    </button>
                  </div>
                </td>
                <td>{{ data.is_check_out == 1 ? "YES" : "NO" }}</td>
                <td>
                  <div
                    class="btn-group btn-group-sm"
                    *ngIf="data.can_widhraw == true"
                  >
                    <button
                      class="btn-danger"
                      type="button"
                      (click)="cancelReq(data)"
                      *ngIf="data.can_widhraw == true"
                    >
                      Withdraw Request
                    </button>
                  </div>
                  <div class="btn-group btn-group-sm">
                    <button
                      class="btn-warning"
                      type="button"
                      *ngIf="data.is_approved == '' && data.is_cancel == 1"
                    >
                      Cancelled
                    </button>
                  </div>
                  <div
                    class="btn-group btn-group-sm"
                    *ngIf="data.is_check_in == 1 && data.is_check_out == 0"
                  >
                    <button
                      class="btn-danger"
                      type="button"
                      (click)="checkOut(data)"
                    >
                      CheckOut
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!--end page body contant -->
    </div>
  </div>
</div>
<!-- /Page Wrapper -->

<div id="qr_code_modal" class="modal custom-modal fade" role="dialog" #outerDiv>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content" *ngIf="empDtata">
      <div class="modal-header">
        <h5 class="modal-title" id="zero_country_form_title">QR Code</h5>
        <button
          type="button"
          class="close"
          (click)="closeModal('#qr_code_modal')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="myPrint">
        <!-- qe-code -->
        <div class="row add-p-tb">
          <div class="col-12 d-flex align-items-center bg-white">
            <div class="container my-auto">
              <div class="row menu-column border border-rad">
                <div
                  class="col-12 bg-primary text-white menu-head border-rad h4 text-center add-p-tb"
                >
                  Workpermission Details
                </div>
                <div class="col col-pn">
                  <table class="table m-b-0" *ngIf="empDtata">
                    <tr>
                      <td>Employee</td>
                      <td>
                        {{ empDtata.booked_usrname }} -
                        {{ empDtata.BookedForEmpName }}
                      </td>
                    </tr>
                    <tr>
                      <td>Office</td>
                      <td>{{ empDtata.offc_name }}</td>
                    </tr>
                    <tr>
                      <td>Visit Date</td>
                      <td>
                        {{ empDtata.book_date_from | date : "dd/MM/yyyy" }}
                      </td>
                    </tr>
                    <tr>
                      <td>Book Start Time From</td>
                      <td>{{ empDtata.book_time_from }}</td>
                    </tr>
                    <!-- <tr>
                              <td>End Date</td>
                              <td>{{empDtata.end_date_of_visit | date: 'dd/MM/yyyy'}}</td>
                          </tr> -->
                    <tr>
                      <td>Book Start Time To</td>
                      <td>{{ empDtata.book_time_to }}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- <div class="row">
               <div class="col-12 error-box">
                   <span *ngIf="response.status">
                    <img src="assets/img/valid.png" alt="" style="height: 80px;width: 80px;">
                    <div><b>{{response.msg}}</b></div>
                   </span>
                   <span *ngIf="!response.status">
                    <img src="assets/img/invalid.png" alt="" style="height: 80px;width: 80px;">
                    <div><b>{{response.msg}}</b></div>
                   </span>
               </div>
            </div> -->
            </div>
          </div>
        </div>
        <!-- end qr-code -->

        <div class="text-center">
          <img
            src="{{ qrimage }}"
            alt="QR Code Image"
            class="img-print qu-size"
          />
        </div>
        <div class="row">
          <div class="col-md-12 mt-3 text-center not-print">
            <button
              class="btn btn-lg btn-warning"
              type="button"
              (click)="printBarcode()"
              title="Print"
            >
              <i class="fa fa-print" aria-hidden="true"></i> Print
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
